import { GET_PROFILE } from '../apiEndpoint';
import { educationAxios } from '../http/http'

export default function getProfile(emailid) {
    return educationAxios.get(GET_PROFILE+'?user_email='+emailid
    );
} 